import SelectionToolData from '../data/SelectionToolData'
import store from '../store'
const SelectionToolEngine = {
  install(Vue, options) {
    /**
     * It's unclear if we'll need custom config to be passed to here
     * at the moment, but this is where it would get collected to.
     */
    // eslint-disable-next-line no-unused-vars
    const config = { ...options }
    //pass in the option {testData : SelectionToolTestData} in order to use a testing set of data
    const selectionData = Object.keys(config).includes('testData')
      ? config['testData']
      : Object.assign(SelectionToolData)
    const STE_QUESTIONS = selectionData.questions
    const STE_QUESTION_COUNT = selectionData.questions.length
    const STE_OUTCOMES = selectionData.outcomes
    const STE_OUTCOME_COUNT = selectionData.outcomes.length
    //This dictionary holds all the definitions for all the outcomes
    let ste_definitions = null
    let ste_flatDefinitions = null

    Vue.prototype.ste_genDefs = function() {
      var answers = {}
      for (var i = 0; i < STE_OUTCOME_COUNT; i++) {
        answers[STE_OUTCOMES[i].name] = STE_OUTCOMES[i].responses
      }
      return answers
    }
    /* use ste_get_defs() to access the list of defs, since we have to create them first */
    Vue.prototype.ste_getDefs = function() {
      if (ste_definitions == null) {
        ste_definitions = this.ste_genDefs()
      }
      return ste_definitions
    }
    /* use ste_getFlatDefs() to access the list of flat defs, since we have to create them first */
    Vue.prototype.ste_getFlatDefs = function() {
      if (ste_flatDefinitions == null) {
        ste_flatDefinitions = this.ste_createFlatDefs()
      }
      return ste_flatDefinitions
    }
    /* ste_createFlatDefs
    gets definitions from outcomes, then makes a dict from it
    (id) => (value) where value is an array of all necessary responses
    'likes-traffic-lights': ["1-true"]
    this function creates a dictionary for all defs, where the value is an array of STRING FORMAT responses
    */
    Vue.prototype.ste_createFlatDefs = function() {
      let defs = this.ste_getDefs()
      let result = {}
      /*
      console.log('defs')
      console.log(defs)
      */
      Object.keys(defs).forEach(function(def_key) {
        let this_rule = defs[def_key]
        let rules = []
        Object.keys(this_rule).forEach(function(rule_key) {
          rules.push(
            this_rule[rule_key]['id'] + '-' + this_rule[rule_key]['value']
          )
        })
        result[def_key] = rules
      })
      return result
    }
    /* ste_createFlatResponses
    similar to 'flatDefs' function, this gets current responses from Store, then makes an array from them
    it transforms the response from key-value to a combined STRING FORMAT [{1:true}] => "1-true"
    this function creates an array of all of those
    example: ["1-false", "2-false", "3-false"]
    when questions 1, 2 and 3 were answered with 'false'
    */
    Vue.prototype.ste_createFlatResponses = function() {
      let responses = store.state.responses
      let result = []
      Object.keys(responses).forEach(function(key) {
        result.push(responses[key]['id'] + '-' + responses[key]['value'])
      })
      return result
    }
    Vue.prototype.ste_actionsNeeded = function() {
      //run reactive phase
      return this.ste_reactivePhase() //returns array of all pages that need to be hidden & gutted from answers
    }
    /**
     * sc_set_value => ste_setValue
     */
    Vue.prototype.ste_nextStep = function(question_name) {
      //return either next question or outcome in object form
      //where 'question_name' is the question handle like: 'q3'
      //log the question event
      this.ste_logEvent('question-answered', question_name)
      //check for diagnosis
      let diag = this.ste_diagnosisPhase()
      if (diag) {
        //log the 'outcome'
        this.ste_logEvent('outcome', diag.name)
        return diag
      }
      return this.ste_nextQuestionPhase(question_name) //spits out object (object tells us if its question or outcome)
    }
    /**
     * event_log => ste_logEvent
     */
    Vue.prototype.ste_logEvent = function(action, label) {
      // this is our GTM helper function, it pushes events into the GTM datalayer
      if (config['gtm']) {
        var gtm_name = config['gtm']
        var thisDataLayer = (window[gtm_name] = window[gtm_name] || [])
        //SEND GTM EVENT
        thisDataLayer.push({
          event: 'selection-tool',
          eventCategory: 'st-event',
          eventAction: action,
          eventLabel: label
        })
        console.log(gtm_name + ' event pushed...')
        //END GTM EVENT
      }
      return true
    }
    /**
     * reactive_phase => ste_reactivePhase
     *  this function is intended to let the system know when we need to hide a previously shown question due to a change in an answer
     */
    Vue.prototype.ste_reactivePhase = function() {
      //iterate over list of answered Q's
      //look for questions, which we have answered, which have been 'disqualified' due to the change in answer.
      //console.log('reactive phase started')
      const CURRENT_ANSWERS = this.store_getAnswers()
      const CURRENT_FLAT_ANSWERS = this.ste_createFlatResponses()
      let answers_by_id = [] //make into an array of the IDs of questions answers, ex: [1, 2]
      let actionsNeededArr = Array() //return arr, list of questions that must be hidden
      Object.keys(CURRENT_ANSWERS).forEach(function(key) {
        answers_by_id.push(CURRENT_ANSWERS[key]['id'])
      })
      STE_QUESTIONS.forEach(question => {
        //is this question in our list of answered questions
        if (answers_by_id.includes(question.id)) {
          //console.log('this question has been answered')
          //does it have pre-reqs?
          if (question.prereq !== undefined) {
            //means pre-req exists!
            //lets add it to an array
            //console.log('Element has prereq')
            //is one of those pre-reqs the current question?
            let flat_question_prereqs = ste_flattener(question.prereq)
            flat_question_prereqs.forEach(req => {
              if (!CURRENT_FLAT_ANSWERS.includes(req)) {
                //this requirement is not fulfilled. throw out the question
                // console.log('REQUIREMENT NOT MET, HIDE: ' + question.name)
                // @todo
                // add in a HOOK to tell the frontend to HIDE THIS QUESTION (and remove its attached answers from the store)
                actionsNeededArr.push(question.name)
              }
            })
            //console.log('no problems found, all prereqs met')
          }
        }
        //--if not then we skip it, irrelevant?
      })
      //console.log('ending reactive phase')
      return actionsNeededArr
    }
    /**
     * next_symptom_phase => ste_nextQuestionPhase
     * assuming no diagnose can be made... whats the next question we show
     * startPoint = the handle for a Question, like: 'q1'
     * returns Question Object
     */
    Vue.prototype.ste_nextQuestionPhase = function(startPoint) {
      let flatResponses = this.ste_createFlatResponses()
      let totalResponsesSoFar = flatResponses.length
      //lets check if we are out of runway.. just for the heck of it
      if (totalResponsesSoFar >= STE_QUESTION_COUNT) {
        // console.log('Everything is answered? Maybe time to diagnose')
        return false
      }
      //console.log('starting nextQuestionPhase - starting point: ' + startPoint)
      const tmpAnswers = this.ste_createFlatResponses()
      /*
      let lastQuestion = STE_QUESTIONS.filter(obj => {
        return obj.name === startPoint
      }).pop()
      */
      let lastQuestionNum = parseInt(startPoint.replace('q', ''))
      //console.log(lastQuestionNum)
      //default path - show next question in seqence
      //unless... it has a pre-req that is unfulfilled
      let nextQuestionNum = lastQuestionNum + 1
      let nextQuestionName = 'q' + nextQuestionNum.toString()
      //console.log('evaluating ' + nextQuestionName + '...')
      let nextQuestion = STE_QUESTIONS.filter(obj => {
        return obj.name === nextQuestionName
      }).pop()
      if (nextQuestion === undefined) {
        //console.log('Cannot locate next question. Punting...')
        return false
      }
      //does next question have pre-req
      let nextQuestionPrereq = nextQuestion.prereq
      if (nextQuestionPrereq === undefined) {
        //no prereq for next Q... EZ CLAP!
        //console.log('Next Question Located')
        return nextQuestion
      }
      //it does have a prereq... Well, is it fulfilled? lets pull our answers
      let nextQuestionFlatPreReqs = ste_flattener(nextQuestionPrereq)
      //console.log(nextQuestionFlatPreReqs)
      if (ste_detectSubset(nextQuestionFlatPreReqs, tmpAnswers)) {
        //console.log('Match Detected - Subset Match')
        //return next question, it does have pre-reqs but they are fulfilled
        //console.log('Next Question Located')
        return nextQuestion
      } else {
        //pre-reqs not met
        //lets skip this question and restart the cycle with the next question in the sequence
        //console.log('pre-reqs not met, trying next-in-line')
        return this.ste_nextQuestionPhase(nextQuestionName)
      }
    }
    /**
     * diagnosis_phase => ste_outcome?
     */
    Vue.prototype.ste_diagnosisPhase = function() {
      //Question - can there be multiple diagnoses? what happens when 2 diagnoses are matched at same time, which gets precendence?
      //above can probably be avoided with proper logic building at the start..
      //console.log('Checking for diagnosis match')
      //check if we have a solution, run definition against answers
      //if we have a solution, lets unhide it.
      let solutionFlag = false
      let matchArr = []
      const definitions = this.ste_getFlatDefs()
      // for each OUTCOME, get DEFINITION
      const tmpAnswers = this.ste_createFlatResponses()
      // get all current answers from store
      Object.keys(definitions).forEach(function(key) {
        //for each DEFINITION
        //key is the name of the definition 'likes-traffic-lights'
        let definition = definitions[key]
        //console.log(definition)
        // does current ANSWER_KEY match DEFINITION
        //   does it match it exactly, or is it a subset match?
        //   turn on solution flag, and capture definition ID, if solution found
        let is_same =
          definition.length == tmpAnswers.length &&
          definition.every(function(element, index) {
            return element === tmpAnswers[index]
          })
        if (is_same) {
          //console.log('Match Detected - Exact Match')
          matchArr.push(key)
          solutionFlag = true
        }
        if (ste_detectSubset(definition, tmpAnswers)) {
          //console.log('Match Detected - Subset Match')
          matchArr.push(key)
          solutionFlag = true
        }
      })
      // if solution flag, tell the frontend we have a match & log an event
      if (solutionFlag) {
        //console.log('Match Found')
        //console.log(matchArr)
        let last_match = matchArr.pop() //Last in, First Out
        let result = STE_OUTCOMES.filter(obj => {
          return obj.name === last_match
        })
        //console.log(result)
        return result.pop() //strip off the array, just passing Outcome Object
      }
      return solutionFlag //false if no match
    }
    /**
     * diagnosis_phase => ste_outcome?
     */
    Vue.prototype.store_getAnswers = function() {
      //lets check our answer key
      return store.state.responses
    }
    /**
     * diagnosis_phase => ste_outcome?
     */
    Vue.prototype.store_pushResponse = function(payload) {
      //not sure if this will make it into the process, using for testing
      return store.state.responses.push(payload)
    }
    /**
     * Wipe Store -- for testing only?
     */
    Vue.prototype.store_wipeResponses = function() {
      //DELETES EVERYTHING FROM THE STORE, USING FOR TESTING
      store.state.responses.length = 0
      return true
    }
    /**
     * detect_subset => ???
     */
    function ste_detectSubset(definition, answers) {
      // internal function, detects array subset matches
      // checks if arrayB contains all the elements of arrayA
      let rule_count = 0
      let pos_res_count = 0
      definition.forEach(rule => {
        rule_count += 1
        if (answers.includes(rule)) {
          pos_res_count += 1
        }
      })
      if (pos_res_count == rule_count) {
        return true
      }
      return false
    }
    /* Flattener helper function
     * takes array of objects and returns array of flattened strings (only keeps first level of stuff..)
     */
    function ste_flattener(nonFlatThing) {
      let flatThing = []
      Object.keys(nonFlatThing).forEach(function(obj_key) {
        flatThing.push(obj_key + '-' + nonFlatThing[obj_key])
      })
      return flatThing
    }
    /**
     * sc_validate_existence_of_required_vars => ste_hasRequiredVars
     */
    Vue.prototype.ste_hasRequiredVars = function(payload) {
      //console.log(payload)
      return payload
    }
  }
}

export default SelectionToolEngine
